import { useCallback, useMemo, useState } from "react";
import { buildLookupEditConfig, buildMainEditConfig } from "../utilities/commerceConfig";

export const useDimensionModal = ({
  config,
  columns,
  relationships,
  rows,
  onRefresh,
}) => {
  const [isOpen, setIsOpen] =
    useState(false);

  const [
    selectedDimension,
    setSelectedDimension,
  ] = useState(null);

  const [modalConfig, setModalConfig] =
    useState(null);

  const mainEditConfig = useMemo(
    () =>
      buildMainEditConfig({
        config,
        columns,
        relationships,
      }),
    [columns, config, relationships]
  );

  const openMainDimension = useCallback(
    (row) => {
      setSelectedDimension({
        entity: config.entity,
        tableName: config.tableName,
        primaryKey: config.primaryKey,
        labelField: config.labelField,
        key:
          row?.fields?.[config.primaryKey] ??
          null,
        label:
          row?.fields?.[config.labelField] ??
          "",
        fields: row?.fields ?? {},
        topVendors: row?.topVendors ?? [],
      });

      setModalConfig(mainEditConfig);
      setIsOpen(true);
    },
    [config, mainEditConfig]
  );

  const openLookupDimension = useCallback(
    (option, relationship) => {
      setSelectedDimension({
        entity: relationship.targetEntity,
        tableName:
          relationship.targetTable,
        primaryKey:
          relationship.targetKey,
        labelField:
          relationship.targetLabel,
        key: option?.key ?? null,
        label: option?.label ?? "",
        fields: option?.fields ?? {},
      });

      setModalConfig(
        buildLookupEditConfig({
          option,
          relationship,
          config,
          rows,
        })
      );

      setIsOpen(true);
    },
    [config, rows]
  );

  const close = useCallback(async (shouldRefresh = false) => {
    setIsOpen(false);
    setSelectedDimension(null);
    setModalConfig(null);

    if (shouldRefresh === true && onRefresh) {
      await onRefresh();
    }
  }, [onRefresh]);

  return {
    isOpen,
    selectedDimension,
    modalConfig,
    openMainDimension,
    openLookupDimension,
    close,
  };
};